export function isFrequencyConfirmed({ isFrequencyLimited, isPopupShownViaCookie, isShownViaBackend, }) {
    return isFrequencyLimited && (isPopupShownViaCookie || isShownViaBackend);
}
export function isWithinLocalConfirmationWindow(confirmedUntil, now = Date.now()) {
    return confirmedUntil !== null && now < confirmedUntil;
}
export function shouldResetFrequencyState(input) {
    return (input.isFrequencyLimited &&
        input.hasBeenShown &&
        !input.isLocallyConfirmed &&
        !input.isPopupShownViaCookie &&
        !input.isShownViaBackend);
}
